import script from "./SearchDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SearchDetail.vue?vue&type=style&index=0&id=38acda75&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38acda75"]])

export default __exports__